import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useState } from "react";
import CalculateAreaInput from "./CalculateAreaInput";
import CalculateStudentCostInput from "./CalculateStudentCostInput";
import CalculateFeatureInput from "./CalculateFeatureInput";

const CalculateCostFeaturesComponent = () => {
  const [calculateType, setCalculateType] = useState<string>();

  const showCalculateInput = (type: string) => {
    switch (type) {
      case "area":
        return (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Calculate Area
            </Typography>

            <CalculateAreaInput />
          </Grid>
        );
      case "studentCost":
        return (
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Calculate Student Cost
            </Typography>

            <CalculateStudentCostInput />
          </Grid>
        );
    }
  };

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Calculate Feature</Typography>
      </Grid>

      <Grid item xs={4}>
        <CalculateFeatureInput
          calculateType={calculateType}
          setCalculateType={setCalculateType}
        />
      </Grid>
      <Grid item xs={8}></Grid>

      {showCalculateInput(calculateType)}
    </SanitizedGrid>
  );
};

export default CalculateCostFeaturesComponent;
